module.exports = __webpack_public_path__ + "img/DNRIL-White-Horiz.7de12bb4.png";